import { CustomProductListState } from "@iewccouk/Store/State/ProductList/ProductListState";
import { ApiHandlerDiscreteParameter, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";

type HandlerType = ApiHandlerDiscreteParameter<
    {
        page: number;
        pageSize?: number;
        scrollPosition?: number;
        isLoading?: boolean;
    },
    CustomProductListState
>;

export const DispatchBeginLoadInfiniteScroll: HandlerType = props => {
    props.dispatch({
        type: "Custom/ProductList/InfiniteScrollLoading",
    } as any);
};

export const InfiniteScroll: HandlerType = props => {
    props.dispatch({
        type: "Custom/ProductList/InfiniteScroll",
        page: props.parameter.page,
        pageSize: props.parameter.pageSize,
        scrollPosition: props.parameter.scrollPosition,
        isLoading: true,
    } as any);
};

// export const DispatchCompleteLoadInfiniteScroll: HandlerType = props => {
//     props.dispatch({
//         type: "Custom/ProductList/InfiniteScrollLoaded",
//     } as any);
// };

export const chain = [
    DispatchBeginLoadInfiniteScroll,
    InfiniteScroll,
    // DispatchLoadMoreProducts,
    // DispatchCompleteLoadInfiniteScroll,
];

const setCustomInfiniteScroll = createHandlerChainRunner(chain, "SetCustomInfiniteScroll");
export default setCustomInfiniteScroll;
